var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F1F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2002 9V13.8L15.4002 17L12.2002 20.2V25H21.8002V20.2L18.6002 17L21.8002 13.8V9H12.2002Z",
    fill: "#214BA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalHours);
export default __webpack_public_path__ + "static/media/total-hours.feecf0e9e1f638d5748276e3ce71fe06.svg";
export { ForwardRef as ReactComponent };